import {
  IconBrandFacebook,
  IconBrandTelegram,
  IconBrandTwitter,
  IconBrandWhatsapp,
  IconMail,
} from '@tabler/icons-react';
import {
  EmailShareButton,
  FacebookShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'next-share';
import { Group } from '@mantine/core';

export interface ShareBarProps {
  url: string;
  title?: string;
}

// `next-share`'s share buttons render their own <button>. Wrapping them in
// Mantine's <ActionIcon> would nest a <button> inside a <button> (invalid HTML
// + React warning). Style the share button itself instead.
const shareButtonStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 36,
  height: 36,
  border: 0,
  background: 'transparent',
  cursor: 'pointer',
  padding: 0,
};

const ShareBar = ({ url, title }: ShareBarProps) => (
  <Group
    position="center"
    mt="xl"
    spacing={0}
    sx={{ backgroundColor: '#ededed', borderRadius: 20, overflow: 'hidden' }}
  >
    <FacebookShareButton url={url} style={shareButtonStyle}>
      <IconBrandFacebook size={20} />
    </FacebookShareButton>
    <TelegramShareButton url={url} style={shareButtonStyle}>
      <IconBrandTelegram size={20} />
    </TelegramShareButton>
    <EmailShareButton url={url} subject={title} style={shareButtonStyle}>
      <IconMail size={20} />
    </EmailShareButton>
    <TwitterShareButton url={url} style={shareButtonStyle}>
      <IconBrandTwitter size={20} />
    </TwitterShareButton>
    <WhatsappShareButton url={url} style={shareButtonStyle}>
      <IconBrandWhatsapp size={20} />
    </WhatsappShareButton>
  </Group>
);

export default ShareBar;
